// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"ee0b5e13","379":"0844f287","453":"3f1fb51b","629":"aa394509","720":"20bb2be8","962":"44822c1b"}[chunkId] + ".chunk.js";
};